import 'leaflet/dist/leaflet.css';
// Configurar iconos por defecto de Leaflet
export default function installLeaflet() {
    // Leaflet CSS ya se importa automáticamente
    // Los iconos se configurarán dinámicamente en los componentes
    console.log('Leaflet plugin installed');
}
